webpackJsonp([279896264988230],{

/***/ 1413:
/***/ (function(module, exports) {

	module.exports = {"data":{"allBlogJson":{"edges":[{"node":{"title":"Salesforce Developer: The Lucrative Coding Career You’ve Never Heard Of","metaDescription":"Looking for resources as you learn to code? The Code Fellows blog features helpful tutorials, alumni stories, student projects, school news, and more!","slug":"blog/salesforce-developer-the-lucrative-coding-career-youve-never-heard-of","createdAt":"2017-03-23T23:33:33.285Z","blogAuthor":{"fields":{"name":"Scott Mantei","slug":"blog/author/scott-mantei"}},"imageHeader":{"fields":{"file":{"url":"//images.ctfassets.net/k428n7s2pxlu/4w7qCXlTPOqCqaOGmySEcu/f0ac4b5241564991c1748b53ca89aaef/blog-post-blog-salesforce-developer-the-lucrative-coding-career-youve-never-heard-of.jpg"}}}}}]},"authorJson":{"name":"Scott Mantei","slug":"blog/author/scott-mantei","twitter":null,"linkedIn":null,"website":null,"biography":null,"image":null}},"pathContext":{"slug":"blog/author/scott-mantei"}}

/***/ })

});


// WEBPACK FOOTER //
// path---blog-author-scott-mantei-354eecb46996f64bd5a1.js